import { SVPercentageInput } from '@/components/core';
import { FORM_FIELDS } from '@/constants/formFields';
import { Card, Typography, Grid } from '@mui/material';

const SAVINGS_INTEREST_RATE_MAX = 10;

export default function SavingsInterestSection() {
  return (
    <Card>
      <Typography variant="h5" mb={2}>
        Savings Interest Rate
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Enter the interest rate that the system will apply for all new savings
        accounts the company creates.
      </Typography>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, md: 6 }}>
          <SVPercentageInput
            name="rateSavingInterest"
            {...FORM_FIELDS.SAVINGS_INTEREST_RATE}
            max={SAVINGS_INTEREST_RATE_MAX}
          />
        </Grid>
      </Grid>
    </Card>
  );
}
